import useIngredientGroups from './useIngredientGroups';

export default useIngredientGroups;
